import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AssinaturaService } from './assinatura.service';
import { Utils } from '../shared/utils';

@Component({
  selector: 'app-govbr-callback',
  templateUrl: './govbr-callback.component.html',
  styleUrls: ['./govbr-callback.component.css'],
  providers: [AssinaturaService, Utils]
})
export class GovbrCallbackComponent implements OnInit {
  public processando: boolean = true;
  public status: 'processando' | 'sucesso' | 'erro' = 'processando';
  public mensagem: string = 'Processando sua assinatura digital com a conta GOV.BR...';
  public isBronze: boolean = false;
  public upgradeUrl: string = 'https://confiabilidades.acesso.gov.br/';
  public assinaturaId: number = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private assinaturaService: AssinaturaService,
    private utils: Utils
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const code = params['code'];
      const state = params['state'];
      const error = params['error'];
      const errorDescription = params['error_description'];

      if (error) {
        this.processando = false;
        this.status = 'erro';
        this.mensagem = errorDescription || 'A autorização com o GOV.BR foi cancelada ou não foi concluída.';
        return;
      }

      if (!code) {
        this.processando = false;
        this.status = 'erro';
        this.mensagem = 'Código de autorização não recebido do GOV.BR.';
        return;
      }

      // Tenta extrair a assinatura_id a partir do state codificado em base64
      let idFromState = null;
      if (state) {
        try {
          const decoded = JSON.parse(atob(state));
          if (decoded && decoded.assinatura_id) {
            idFromState = decoded.assinatura_id;
          }
        } catch (e) {
        }
      }

      const id = idFromState || sessionStorage.getItem('govbr_assinatura_id');

      if (!id) {
        this.processando = false;
        this.status = 'erro';
        this.mensagem = 'Identificador do documento a assinar não foi localizado.';
        return;
      }

      this.assinaturaId = Number(id);
      this.concluir(this.assinaturaId, code, state);
    });
  }

  concluir(id: number, code: string, state: string): void {
    this.processando = true;
    this.status = 'processando';

    this.assinaturaService.concluirGovBr(id, code, state)
      .then(resp => {
        this.processando = false;
        this.status = 'sucesso';
        this.mensagem = 'Documento assinado com sucesso via GOV.BR!';
        sessionStorage.removeItem('govbr_assinatura_id');

        setTimeout(() => {
          this.router.navigate(['/assinaturas']);
        }, 2500);
      })
      .catch(err => {
        this.processando = false;
        this.status = 'erro';

        const errMsg = typeof err === 'string' ? err : (err && err.message ? err.message : 'Falha ao processar assinatura.');
        this.mensagem = errMsg;

        if (errMsg.indexOf('Prata ou Ouro') > -1 || errMsg.indexOf('bronze') > -1) {
          this.isBronze = true;
        }
      });
  }

  voltar(): void {
    this.router.navigate(['/assinaturas']);
  }
}



// WEBPACK FOOTER //
// ./src/app/assinaturas/govbr-callback.component.ts